import React from 'react'
import styles from './class-card.scss'
import { useHistory } from 'react-router-dom'

const ClassCard = ({ addClass, classInfo }) => {
  const history = useHistory()
  return (
    <div className={styles.currentCard}>
      {
        addClass
          ? <div className={styles.addCard}>
            <span>+</span>
            <span>{addClass}</span>
          </div>
          : <div className={styles.classCard}>
            <div className={styles.pic}>
              <div
                className={styles.cover}
                style={{
                  backgroundImage: classInfo.cover
                    ? `url(${classInfo.cover})`
                    : `url(${window.config.staticURL}/cover/class/default.png)`
                }}
              ></div>
            </div>
            <div className={styles.description}>
              <p>{classInfo.name || ''}</p>
              <p>{classInfo.school_name || ''}</p>
            </div>
          </div>
      }
    </div>
  )
}

export default ClassCard
